<script>

export default {
	name: 'LoadingScreen',
	
	components: {
	
	},
	
	data() {
		return {
			
		}
	},
	
	props: {'isLoading':Boolean},

	mounted:function(){
		
	},
	
	methods: {
		
	},	
	
	watch: {
		
	},

	computed:{
		
	},
	
}

</script>

<template>
	<div>
		<div v-show="isLoading" class="preloader"><div class="spinner"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div></div>
	</div>
</template>


